import DataTable_vue_vue_type_script_setup_true_lang_default from "./DataTable.vue_vue_type_script_setup_true_lang.js";
//#region src/v2/components/data-table/DataTable.vue
var DataTable_default = DataTable_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { DataTable_default as default };

//# sourceMappingURL=DataTable.vue.js.map